module.exports = __webpack_public_path__ + "static/RST-USB-Kabel-aa59164b9035f856bd8ac64e5b772c2b.jpg";